import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { updateItemApi } from "api/shopping-cart/updateItemApi";
import { sendUpdateCartEvent } from "../../util/analytics/sendUpdateCartEvent";
import { hideLoader } from "../loader/hideLoader";
import { showLoader } from "../loader/showLoader";
import { openModal } from "../modal/openModal";
import { refreshShoppingCart } from "./refreshShoppingCart";
import { removeShoppingCartItem } from "./removeShoppingCartItem";

export function updateItem(
  product: ICompactProduct,
  quantity: any,
  callback: any,
  insufficientStockModalCallback = null,
) {
  const { sku } = product;
  // when delete button clicks
  if (quantity === 0) {
    return removeShoppingCartItem(product);
  }

  return (dispatch: any, getState: any) => {
    dispatch(showLoader());
    const { selectedVehicle } = getState().garage;
    updateItemApi(sku, quantity).then((response) => {
      sendUpdateCartEvent({ ...product, quantity }, selectedVehicle);
      dispatch(hideLoader());
      // call the refresh
      dispatch(refreshShoppingCart());

      const { data } = response;
      if (!data.successful) {
        dispatch(
          openModal("insufficientStock", {
            failureMessage: data.failureMessage,
            product,
            errorType: data.errorType,
            onClose: () => {
              if (insufficientStockModalCallback) {
                insufficientStockModalCallback(response.data);
              }
            },
          }),
        );
      }
      if (callback) {
        callback(response.data);
      }
    });
  };
}
